const injectAlpha = (rgb, alpha) => {
  // Extract the RGB values
  const matches = rgb.match(/\d+/g); // gets ["139", "210", "211"]
  if (!matches || matches.length < 3) {
    throw new Error("Invalid RGB format");
  }

  const [r, g, b] = matches;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Renders an Orb component as a fullscreen radial gradient background.
 *
 * @param {string} color - The base RGB color for the gradient.
 * @param {string} [top=""] - The CSS top position value.
 * @param {string} [bottom=""] - The CSS bottom position value.
 * @param {string} [right=""] - The CSS right position value.
 * @param {string} [left=""] - The CSS left position value.
 */

/*******  a9cb4fd5-15c9-4a3f-8eac-43a164013e83  *******/
const Orb = ({ color, top = "", bottom = "", right = "", left = "", width="100vh", height="100vh" }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        width: width,
        height: height,
        background: "radial-gradient(50% 50% at 50% 50%, " + injectAlpha(color, 0.3) + "0%, " + injectAlpha(color, 0) + " 100%)",
        pointerEvents: "none",
        zIndex: -1
      }}
    ></div>
  );
};

export default Orb;
